class ImageLightbox {
  constructor() {
    this.init();
  }

  init() {
    $(document).on('click', 'a.lightbox', (e) => {
      console.log('click');
      e.preventDefault();
      const $link = $(e.currentTarget);
      const imageUrl = $link.attr('href');
      let descriptionText = $link.data('description');

      if (descriptionText === undefined) {
        const $description = $link.find('figcaption');
        descriptionText = $description.length ? $description.html() : '';
      }

      this.open(imageUrl, descriptionText);
    });
  }

  open(imageUrl, descriptionText) {
    let $lightbox = $('.lightbox-overlay');

    if ($lightbox.length === 0) {
      $lightbox = $(`
        <div class="lightbox-overlay">
          <div class="lightbox-canvas">
            <div class="lightbox-close">×</div>
            <img src="" class="lightbox-image">
            <div class="lightbox-description"></div>
          </div>
        </div>
      `);
      $('body').append($lightbox);

      $lightbox.on('click', (e) => {
        if ($(e.target).hasClass('lightbox-overlay') || $(e.target).hasClass('lightbox-close')) {
          this.close();
        }
      });
    }

    $lightbox.find('.lightbox-image').attr('src', imageUrl);
    $lightbox.find('.lightbox-description').html(descriptionText);
    if (descriptionText) {
      $lightbox.find('.lightbox-description').show();
    } else {
      $lightbox.find('.lightbox-description').hide();
    }

    $lightbox.fadeIn(200).addClass('is-active');
    $('body').addClass('has-lightbox');

    $(document).on('keyup.lightbox', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  close() {
    $('.lightbox-overlay').fadeOut(200, function() {
      $(this).removeClass('is-active');
    });
    $('body').removeClass('has-lightbox');
    $(document).off('keyup.lightbox');
  }
}

export default ImageLightbox;
